import { StatelessComponent } from 'react'
import * as styles from 'components/features/external/ExternalFooter/ExternalFooter.styl'
import JoinButton from 'components/features/pfm/JoinButton/JoinButton'
import SocialButton from 'components/features/socialFeed/SocialButton/SocialButton'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import MobileAppBadges from 'components/molecules/MobileAppBadges'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

const ExternalFooter: StatelessComponent = () => (
  <footer className={ styles.footer } data-qa-marker='external-footer'>
    <h2 className={ styles.title }>
      Join our<span className={ styles.lineBreak }>{ ' ' }</span>growing community<span className={ styles.lineBreak }>{ ' ' }</span>today.
    </h2>

    <AnalyticsClick
      className={ styles.joinButtonWrapper }
      category='page_controls-homepage'
      action='click-join_cta'
      label='footer'
    >
      <JoinButton shadow='light' />
    </AnalyticsClick>

    <nav className={ styles.navigation }>
      <NavigationLink className={ styles.navigationLink } qaMarker='about-link' to='about'>
        About
      </NavigationLink>
      <NavigationLink className={ styles.navigationLink } qaMarker='faq-link' to='faq'>
        FAQ
      </NavigationLink>
      <NavigationLink className={ styles.navigationLink } qaMarker='coaching-link' to='coaching'>
        Coaching
      </NavigationLink>
    </nav>

    <section className={ styles.mobileAppBadgesWrapper }>
      <MobileAppBadges />
    </section>

    <div className={ styles.socialButtons }>
      <div className={ styles.socialButtonWrapper }>
        <SocialButton qaMarker='facebook-link' type='facebook' />
      </div>
      <div className={ styles.socialButtonWrapper }>
        <SocialButton qaMarker='twitter-link' type='twitter' />
      </div>
      <div className={ styles.socialButtonWrapper }>
        <SocialButton qaMarker='linkedin-link' type='linkedin' />
      </div>
    </div>

    <section className={ styles.secondaryNavigation }>
      <NavigationLink className={ styles.secondaryNavigationLink } qaMarker='press-link' to='press'>
        Press
      </NavigationLink>
      <NavigationLink className={ styles.secondaryNavigationLink } qaMarker='privacy-link' to='privacy'>
        Privacy
      </NavigationLink>
      <NavigationLink className={ styles.secondaryNavigationLink } qaMarker='security-link' to='security'>
        Security
      </NavigationLink>
      <NavigationLink className={ styles.secondaryNavigationLink } qaMarker='terms-link' to='terms'>
        Terms
      </NavigationLink>
    </section>
  </footer>
)

export default ExternalFooter
